import React, { useEffect, useState, useRef } from "react";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import PopupLoader from "../popups/PopupLoader";
import { MDBBtn, MDBIcon, MDBModalFooter, MDBAutocomplete } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import { LocAddressSeach } from "../../apiclients/streamsapi_bridge";
import { Controller } from "react-hook-form";
import { CANADA, USA } from "../../components/images";

function SMSBrandDetails({
  register,
  watch,
  errors,
  setValue,
  orgType,
  clearErrors,
  isLoading,
  setIsLoading,
  control,
  brandstatus,
}) {
  const navigate = useNavigate();
  const [countryMainList, setcountryMainList] = useState([]);
  const [countryList, setcountryList] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [stockExchangeList, setstockExchangeList] = useState([]);
  const [industryTypes, setindustryTypes] = useState([]);
  const [legalTypes, setlegalTypes] = useState([]);
  const [dunsgiinleiList, setdunsgiinleiList] = useState({});
  const [locationList, setlocationList] = useState([]);
  const [billingGroupList, setbillingGroupList] = useState([]);
  const [displayalert, setdisplayalert] = useState(false);
  const alertToggle = () => setdisplayalert(!displayalert);
  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    getBrandMisc();
  }, []);

  async function getBrandMisc() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["brand_cmpg_mics", "all_locations", "billinggroups"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates,
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
    // setSourceNumber(basicInfo.misc.free_dids);
    setcountryMainList(
      basicInfo?.misc?.brand_cmpg_mics?.dropDown?.country_list ?? [],
    );
    setcountryList(
      basicInfo?.misc?.brand_cmpg_mics?.dropDown?.country_list ?? [],
    );
    setstateList(basicInfo?.misc?.brand_cmpg_mics?.dropDown?.state_list ?? []);
    setindustryTypes(
      basicInfo?.misc?.brand_cmpg_mics?.dropDown?.acc_industry_type_list ?? [],
    );
    setstockExchangeList(
      basicInfo?.misc?.brand_cmpg_mics?.dropDown?.stock_list ?? [],
    );
    setlegalTypes(
      basicInfo?.misc?.brand_cmpg_mics?.dropDown?.acc_org_type_list ?? [],
    );
    setdunsgiinleiList(
      basicInfo?.misc?.brand_registration?.duns_giin_lei ?? {},
    );
    setlocationList(basicInfo?.misc?.all_locations ?? []);
    setbillingGroupList(basicInfo?.misc?.billinggroups ?? []);
  }
  function handleOrganizationChange(e) {
    e.preventDefault();
    setValue("brand_details.org_type", parseInt(e.target.value), {
      shouldDirty: true,
    });
    if (parseInt(e.target.value) === 5) {
      setValue("brand_details.country", "US", { shouldDirty: true });
      setcountryList(
        countryMainList.filter((country) => country.cscode === "US"),
      );
    } else {
      setcountryList([...countryMainList]);
      if (parseInt(e.target.value) === 4) {
        alertToggle();
      }
    }
  }
  function handleOk(e) {
    e.preventDefault();
    setValue("brand_details.org_type", 0, {
      shouldDirty: true,
    });
    alertToggle();
  }

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("brand_details.street");
      setValue("brand_details.street", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };
  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("brand_details.street", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("brand_details.city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = stateList.find(
        (state) => state.statecode.trim() === address.state.trim(),
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("brand_details.state", stateObj.sid, {
          shouldDirty: true,
        });
      }
    }
    if (address.zipcode) {
      setValue("brand_details.zipcode", address.zipcode, { shouldDirty: true });
    }
  }

  return (
    <>
      <div className="general-settings">Brand Details</div>
      <div>
        <div class="add-numbermain">
          <div class="tel-numbers">Legal Company Name <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                readOnly={brandstatus !== "Unverified"}
                {...register("brand_details.company_name", {
                  required: "Legal Company Name is required",
                })}
              />
              {errors?.brand_details?.company_name && (
                <p className="text-danger">
                  {errors?.brand_details?.company_name?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">DBA Name <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                maxLength={150}
                name="groupName"
                {...register("brand_details.brand_name", {
                  required: "DBA Name is required",
                  validate: (value) =>
                    value?.trim() !== "" || "DBA Name cannot be empty",
                })}
              />
              {errors?.brand_details?.brand_name && (
                <p className="text-danger">
                  {errors?.brand_details?.brand_name?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">Issuing Country <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              {brandstatus !== "Unverified" ? (
                <input
                  class="form-control"
                  name="groupName"
                  value={watch("brand_details.countryName")}
                  readOnly
                />
              ) : (
                 <Controller
                  name="brand_details.country"
                  control={control}
                  rules={{ required: "Issuing Country is required" }}
                  render={({ field }) => (
                    <select
                      class="form-control"
                      name="groupName"
                      value={field.value || ""}
                      onChange={(e) => field.onChange(e.target.value)}
                    >
                      <option value="">-- Select Country --</option>
                      {countryList.map((country) => (
                        <option key={country.id} value={country.id}>{country.cname}</option>
                      ))}
                    </select>
                  )}
                />
              )}
              {/* <option value="">-- Select Country --</option>
                {countryList.map((country) => (
                  <option value={country.cscode}>{country.cname}</option>
                ))}
              </input> */}
              {errors?.brand_details?.country && (
                <p className="text-danger">
                  {errors?.brand_details?.country?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">Legal Formation <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>

          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              {brandstatus !== "Unverified" ? (
                <input
                  className="form-control"
                  name="groupName"
                  readOnly
                  value={watch("brand_details.org_type_name") || ""}
                />
              ) : (
                <Controller
                  name="brand_details.org_type"
                  control={control}
                  rules={{
                    validate: (value) =>
                      (value && String(value) !== "0") ||
                      "Legal Formation is required",
                  }}
                  render={({ field }) => (
                    <select
                      className="form-control"
                      name="groupName"
                      value={field.value || "0"}
                      onChange={(e) => field.onChange(e.target.value)}
                    >
                      <option value="0">-- Select Organization Type --</option>

                      {legalTypes.map((type) => (
                        <option key={type.org_type_id} value={type.org_type_id}>
                          {type.org_type_name}
                        </option>
                      ))}
                    </select>
                  )}
                />
              )}

              {errors?.brand_details?.org_type && (
                <p className="text-danger">
                  {errors.brand_details.org_type.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">EIN/Tax Number <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                readOnly={brandstatus !== "Unverified"}
                 {...register("brand_details.tax_number", {
                  required: "Tax Number/ID/EIN is required",
                })}
              />
              {errors?.brand_details?.tax_number && (
                <p className="text-danger">
                  {errors?.brand_details?.tax_number?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">Street Address <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <Controller
                name="brand_details.street"
                control={control}
                rules={{
                  required: "Street Address is required",
                  validate: (value) => {
                    if (typeof value === "string") {
                      return (
                        value.trim() !== "" || "Street Address cannot be empty"
                      );
                    }
                    return (
                      value?.street_line?.trim() !== "" ||
                      "Street Address cannot be empty"
                    );
                  },
                }}
                render={({ field }) => (
                  <MDBAutocomplete
                    data={addressReasults}
                    value={field.value}
                    displayValue={(address) => address.street_line}
                    isLoading={isLoading}
                    placeholder="Address 1"
                    onSearch={handleSearchAddressChange}
                    onSelect={(e) => {
                      allowAPI.current = false;
                      setisDisplay(false);
                      field.onChange(e); // Update form state
                    }}
                    itemContent={(address) => (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          allowAPI.current = false;
                          handleAddressSelect(address);
                          field.onChange(address); // Update form state
                        }}
                      >
                        {address.country && (
                          <img
                            src={address.country === "USA" ? USA : CANADA}
                            className="me-3"
                            width={25}
                          />
                        )}
                        {address.street_line || ""}
                        {address.secondary ? ", " + address.secondary : ""}
                        {address.city ? ", " + address.city : ""}
                        {address.state ? ", " + address.state : ""}
                        {address.zipcode ? ", " + address.zipcode : ""}
                      </div>
                    )}
                  />
                )}
              />
              {errors?.brand_details?.street && (
                <p className="text-danger">
                  {errors?.brand_details?.street?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* <div class="add-numbermain">
          <div class="tel-numbers">DUNS or GIIN or LEI</div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <select
                class="form-control form-select"
                name="groupName"
                {...register("brand_details.duns_giin_lei", {
                  required: "DUNS or GIIN or LEI Number is required",
                })}
              >
                {Object.entries(dunsgiinleiList).map(([key, value]) => (
                  <option value={value}>{key}</option>
                ))}
              </select>
              {errors?.brand_details?.duns_giin_lei && (
                <p className="text-danger">
                  {errors?.brand_details?.duns_giin_lei?.message}
                </p>
              )}
            </div>
          </div>
        </div> */}

        {/* <div class="add-numbermain">
          <div class="tel-numbers">GIIN Number</div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                {...register("brand_details.duns_giin_lei_num")}
              />
              {errors?.brand_details?.duns_giin_lei_num && (
                <p className="text-danger">
                  {errors?.brand_details?.duns_giin_lei_num?.message}
                </p>
              )}
            </div>
          </div>
        </div> */}

        <div className="add-numbermain">
          <div className="tel-numbers">State <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <Controller
                name="brand_details.state"
                control={control}
                rules={{
                  validate: (value) =>
                    Number(value) > 0 || "State is required",
                 }}
                render={({ field }) => (
                  <select
                    className="form-control form-select"
                    value={watch("brand_details.state") || 0}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                  >
                    <option value={0}>-- Select State --</option>
                    {stateList.map((state) => (
                      <option key={state.sid} value={state.sid}>
                        {state.sname}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors?.brand_details?.state && (
                <p className="text-danger">
                  {errors.brand_details.state.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain always-editable" title="">
         <div className="tel-numbers">
            <label>
            Location<span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span>
            </label>
            </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <Controller
                name="brand_details.location_id"
                control={control}
                rules={{ validate: (value) => Number(value) > 0 || "Location is required" }}
                render={({ field }) => (
                  <select
                    className="form-control form-select"
                    value={watch("brand_details.location_id") || 0}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                  >
                    <option value={0}>-- Select Location --</option>
                    {locationList.map((loc) => (
                      <option key={loc.loc_id} value={loc.loc_id}>
                        {loc.loc_name}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors?.brand_details?.location_id && (
                <p className="text-danger">
                  {errors.brand_details.location_id.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain always-editable" title="">
          <div className="tel-numbers">
            <label>
              Billing Group<span className="required" style={{ margin: "0.2rem", color: "red" }}>*</span>
            </label>
          </div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <Controller
                name="brand_details.billing_group_id"
                control={control}
                  rules={{ validate: (value) => billingGroupList.some((b) => b.groupid === Number(value)) || "Billing group is required" }}
                render={({ field }) => (
                  <select
                    className="form-control form-select"
                    value={watch("brand_details.billing_group_id") || 0}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                  >
                    {billingGroupList.map((bgrp) => (
                      <option key={bgrp.groupid} value={bgrp.groupid}>
                        {bgrp.groupname}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors?.brand_details?.billing_group_id && (
                <p className="text-danger">
                  {errors.brand_details.billing_group_id.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">City <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                {...register("brand_details.city", {
                  required: "City is required",
                })}
              />
              {errors?.brand_details?.city && (
                <p className="text-danger">
                  {errors?.brand_details?.city?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">Zip Code <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                {...register("brand_details.zipcode", {
                  required: "Postal Code/Zip Code is required",
                })}
              />
              {errors?.brand_details?.zipcode && (
                <p className="text-danger">
                  {errors?.brand_details?.zipcode?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div class="add-numbermain">
          <div class="tel-numbers">Business Website / Online Presence <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div class="d-flex w-30">
            <div class="phoneselect w-100">
              <input
                class="form-control"
                name="groupName"
                type="url"
                placeholder="https://www.yourbusiness.com/privacy"
                {...register("brand_details.website", {
                  required: "Business Website / Online Presence is required",
                })}
              />
              {errors?.brand_details?.website && (
                <p className="text-danger d-flex align-items-end justify-content-end" style={{ marginBottom: 0 }}>
                  {errors.brand_details.website.type === "required"
                    ? <>{errors.brand_details.website.message}&nbsp;<MDBIcon fas icon="info-circle" color="danger" className="website-edit-error-tooltip cursor-pointer w-auto pb-1" /></>
                    : <>Please enter a valid Business Website / Online Presence.&nbsp;<MDBIcon fas icon="info-circle" color="danger" className="website-edit-error-tooltip cursor-pointer w-auto pb-1" /></>
                  }
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">Industry Vertical <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <Controller
                name="brand_details.vertical_type"
                control={control}
                rules={{ 
                  validate: (value) =>
                    Number(value) > 0 || "Industry Type is required",
                 }}
                render={({ field }) => (
                  <select
                    className="form-control form-select"
                    value={watch("brand_details.vertical_type") || 0}
                    onChange={(e) => field.onChange(Number(e.target.value))}
                  >
                    <option value={0}>Select Industry Type</option>
                    {industryTypes.map((industry) => (
                      <option
                        key={industry.industry_type_id}
                        value={industry.industry_type_id}
                      >
                        {industry.industry_type}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors?.brand_details?.vertical_type && (
                <p className="text-danger">
                  {errors.brand_details.vertical_type.message}
                </p>
              )}
            </div>
          </div>
        </div>
        {/* {watch("brand_details.org_type") && watch("brand_details.org_type") === "Publicly Traded Company" && ( */}
        {watch("brand_details.org_type_name") == "Publicly Traded Company" && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">Stock Exchange <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <Controller
                    name="brand_details.stock_exchange"
                    control={control}
                    rules={{ 
                      validate: (value) =>
                        Number(value) > 0 || "Stock Exchange is required",
                     }}
                    render={({ field }) => (
                      <select
                        className="form-control form-select"
                        value={
                          watch("brand_details.stock_exchange")
                            ? parseInt(watch("brand_details.stock_exchange"))
                            : 0
                        }
                        onChange={(e) => {
                          e.preventDefault();
                          setValue(
                            "brand_details.stock_exchange",
                            parseInt(e.target.value),
                            { shouldDirty: true },
                          );
                        }}
                      >
                        <option value={0}>Select Stock Exchange</option>
                        {stockExchangeList.map((stock) => (
                          <option key={stock.id} value={stock.id}>
                            {stock.stock_name}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                  {errors?.brand_details?.stock_exchange && (
                    <p className="text-danger">
                      {errors.brand_details.stock_exchange.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div class="add-numbermain">
              <div class="tel-numbers">Stock Symbol <span className="required"  style={{margin:"0.2rem", color:"red"}}>*</span></div>
              <div class="d-flex w-30">
                <div class="phoneselect w-100">
                  <input
                    class="form-control"
                    name="groupName"
                    maxLength={10}
                    {...register("brand_details.stock_symbol", {
                      required: "Stock Symbol is required",
                    })}
                  />
                  {errors?.brand_details?.stock_symbol && (
                    <p className="text-danger">
                      {errors?.brand_details?.stock_symbol?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {displayalert && (
        <PopupLoader
          title="Alert"
          content={
            <>
              <div>
                <span className="phrecording">
                  We are unable to create a brand with Organization type as
                  'Sole Proprietor'. Please contact Carrier Services
                  @800.619.3688 for further assistance.
                </span>
              </div>
              <MDBModalFooter>
                <MDBBtn onClick={(e) => handleOk(e)}>Ok</MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={setdisplayalert}
          onClose={alertToggle}
        />
      )}

      <Tooltip anchorSelect=".website-edit-error-tooltip" place="right-start" className="exampleTooltipLight">
        <div style={{ maxWidth: "280px" }}>
          <p style={{ marginBottom: "6px", color: "#ff6b6b", fontWeight: "700" }}>Errors:</p>
          <ul style={{ paddingLeft: "16px", marginBottom: "10px", color: "#ff6b6b" }}>
            {(errors?.brand_details?.website?.message || "")
              .split("||")
              .filter(Boolean)
              .map((err, i) => (
                <li key={i} style={{ marginBottom: "4px" }}>{err}</li>
              ))}
          </ul>
          <hr style={{ margin: "8px 0", borderColor: "#555" }} />
          <p style={{ marginBottom: "8px" }}>
            Enter a valid Privacy Policy URL in one of the following formats:
          </p>
          <ul style={{ paddingLeft: "18px", marginBottom: "8px" }}>
            <li>domain.com/privacy-policy</li>
            <li>www.domain.com/privacy-policy</li>
            <li>https://domain.com/privacy-policy</li>
          </ul>
          <p style={{ margin: 0 }}>
            <strong>Note:</strong> URLs starting with http:// are not supported.
          </p>
        </div>
      </Tooltip>
    </>
  );
}

export default SMSBrandDetails;
